import React from 'react'
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Typography,
} from '@mui/material'
import { VariantPrivacyType } from '../../../OperationalPlanner.types'

interface VariantPrivacySelectorProps {
  value: VariantPrivacyType
  onChange: (value: VariantPrivacyType) => void
  disabled?: boolean
}

export const VariantPrivacySelector: React.FC<VariantPrivacySelectorProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value as VariantPrivacyType)
  }

  return (
    <Box sx={{ mb: 2 }}>
      <FormControl component="fieldset" disabled={disabled}>
        <FormLabel component="legend" sx={{ mb: 1 }}>
          Variant Privacy
        </FormLabel>
        <RadioGroup
          row
          value={value}
          onChange={handleChange}
          name="variant-privacy-type"
        >
          <FormControlLabel
            value="public"
            control={<Radio />}
            label={
              <Box>
                <Typography variant="body2" fontWeight="medium">
                  Public
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Visible to all users
                </Typography>
              </Box>
            }
          />
          <FormControlLabel
            value="private"
            control={<Radio />}
            label={
              <Box>
                <Typography variant="body2" fontWeight="medium">
                  Private
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  Only visible to you
                </Typography>
              </Box>
            }
          />
        </RadioGroup>
      </FormControl>
    </Box>
  )
}
